<template>
    <!-- 新建工单 -->
    <div class="rzy-page">
        <div class="rzy-top-bar">
            <el-button type="primary" @click="creatWarehouse" style="" icon="el-icon-circle-plus">提交</el-button>
        </div>

        <div class="form-wrap">
            <el-card>

                <el-form :model="g_warehouseInfo" :rules="g_warehouseRelues" ref="warehouseFormRef" inline size="mini">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="单据日期" prop="createTime">
                                <el-date-picker disabled="isDisabled" style="padding-left: 10px;"
                                    v-model="g_warehouseInfo.createTime" type="date" size="large"
                                    value-format="timestamp">
                                </el-date-picker>
                            </el-form-item>

                            <el-form-item label="单据编号" prop="number">
                                <el-input v-model="g_warehouseInfo.number" disabled="isDisabled" placeholder="自动生成">
                                </el-input>
                            </el-form-item>

                            <el-form-item label="客户名称" prop="customer">
                                <el-input v-model="g_warehouseInfo.customer" placeholder="请输入">
                                </el-input>
                            </el-form-item>

                            <el-form-item label="业务员" prop="contact">
                                <el-input v-model="g_warehouseInfo.contact" placeholder="请输入">
                                </el-input>
                            </el-form-item>

                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="地址" prop="address" class="full-width">
                                <el-input v-model="g_warehouseInfo.address" placeholder="请输入" type="textarea" :rows="2">
                                </el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="12">
                            <el-form-item label="备注" prop="remark" class="full-width">
                                <el-input v-model="g_warehouseInfo.remark" placeholder="请输入" type="textarea" :rows="2">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

            </el-card>
        </div>

        <el-row :gutter="10" style="margin-top:10px">
            <el-col :lg="24" :md="24" :sm="24">
                <div class="form-wrap mini auto-width">
                    <div class="toolbar">
                        <div class="col-header">计划出库清单</div>
                        <el-button type="primary" size="mini" icon="el-icon-circle-plus"
                            @click="$refs.warehouseSelect.show()">
                            增行
                        </el-button>
                    </div>
                    <el-table :data="g_warehouseInfo.items" class="craft-order" :row-style="{height: '0'}"
                        :header-cell-style="{padding: 0}" border @selection-change="handleSelectionChange">

                        <!-- 选择多行数据时使用 Checkbox。 -->
                        <!--                        <el-table-column type="selection" width="40" align="center">
                        </el-table-column> -->

                        <el-table-column fixed label="行" width="50px" prop="lineNo" align="center" />

                        <el-table-column label="仓库名称" width="100" align="center">
                            <template slot-scope="data">
                                <el-input v-model="data.row.warehouseName" disabled="isDisabled" />
                            </template>
                        </el-table-column>

                        <el-table-column label="仓位名称" width="100" align="center">
                            <template slot-scope="data">
                                <el-input v-model="data.row.positionName" disabled="isDisabled" />
                            </template>
                        </el-table-column>

                        <el-table-column label="物料编号" width="150" align="center">
                            <template slot-scope="data">
                                <el-input v-model="data.row.materialNumber" disabled="isDisabled" placeholder="未选择">
                                </el-input>
                            </template>
                        </el-table-column>

                        <el-table-column label="物料名称" width="150" align="center">
                            <template slot-scope="data">
                                <el-input v-model="data.row.materialName" disabled="isDisabled" placeholder="未选择">
                                </el-input>
                            </template>
                        </el-table-column>

                        <!-- hcy: "单位"这个数据后台会直接从原料中读取并设置到字段中，前端可以不用传递，只负责显示即可。 -->
                        <el-table-column label="单位" width="100" align="center">
                            <template slot-scope="data">
                                <el-input v-model="data.row.unit" disabled="isDisabled" placeholder="未选择"></el-input>
                            </template>
                        </el-table-column>

                        <el-table-column label="计划出库数量" width="100" align="center">
                            <template slot-scope="data">
                                <el-input v-model="data.row.count" />
                            </template>
                        </el-table-column>

                        <el-table-column label="可用库存" width="100" align="center">
                            <template slot-scope="data">
                                <el-input v-model="data.row.stock" disabled="isDisabled" placeholder="自动计算" />
                            </template>
                        </el-table-column>

                        <el-table-column label="" width="100" align="center">
                            <template slot-scope="data">
                                <el-button type="primary" size="mini" icon="el-icon-circle-plus"
                                    @click="$refs.materialSelect.show(data.row)">
                                    选物料
                                </el-button>
                            </template>
                        </el-table-column>

                        <el-table-column label="" width="100" align="center">
                            <template slot-scope="data">
                                <el-button type="primary" size="mini" icon="el-icon-remove"
                                    @click="delDialogOpend(data.row.lineNo)">
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-col>

        </el-row>


        <!-- 物料选择 弹框 -->
        <material-select ref="materialSelect" @update="updateMaterialDialog()" />
        <!-- 仓库/仓位选择 弹框 -->
        <warehouse-select ref="warehouseSelect" @update="updateWarehouseDialog()" />

        <!-- 删除 对话框 -->
        <el-dialog title="删除仓库" :visible.sync="delDialogVisible" width="20%" @close="delDialogClosed">
            <el-form ref="delFormRef" label-width="90px" :model="delForm">
                <el-form-item label="确定删除?">
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="delDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="delWarehouse">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    import {
        MaterialSelect
    } from '../../../../components/peiBuSelect'
    import {
        WarehouseSelect
    } from '../../../../components/warehouseSelect'

    export default {
        components: {
            MaterialSelect,
            WarehouseSelect,
        },
        data() {
            // 非负浮点数 检测
            var floatCheck = (rules, value, cb) => {
                const ruler = /^\d+(\.\d+)?$/
                if (ruler.test(value)) {
                    return cb()
                }
                cb(new Error('请输入非负浮点数'))
            }


            return {
                // 仓位
                g_position_index: 1,

                g_warehouseInfo: {
                    createTime: (new Date()).getTime(), //单据日期
                    number: '', // 单据编号
                    customer: '', //客户名称
                    contact: '', //业务员(负责人)
                    address: '', //地址
                    remark: '', //备注

                    //仓位列表
                    items: [
                        // {
                        // materialId: 0, //物料ID
                        // materialNumber: '', //物料编号
                        // materialName: '', //物料名称

                        // // parentId: 0, //出库单ID
                        // warehouseName: '', //仓库名称

                        // positionId: 0, //仓位ID
                        // positionName: '', //仓位名称

                        // unit: '', //单位
                        // count: 0, //数量
                        // stock: 0, //可用库存
                        // // remark: '', //备注
                        // },
                    ],
                    items_org: [], //备份后台原始数据
                    items_del: [], //本地删除的数据
                },

                g_warehouseRelues: {
                    XXXX: [{
                        required: true,
                        message: 'XXXXXX',
                        trigger: 'blur'
                    }],

                },

                delDialogVisible: false, //删除 对话框
                g_delIndex: 0, //删除按钮点击了哪一行
            }
        },
        methods: {
            // 外部调用，验证必填的输入框是否都有填写
            getValid() {
                this.$refs.warehouseFormRef.validate(valid => {
                    this.valid = valid
                })
                return this.valid
            },

            //创建or修改 仓库
            creatWarehouse() {
                // 判定数据  是否都填好了
                // if (!this.getValid()) {
                //     return
                // }
                if (!this.checkMaterialTable()) {
                    return
                }

                //hcy: 数量和之前原料是一样的处理，后端传递过来，前端需要转换下。
                for (let i = 0; i < this.g_warehouseInfo.items.length; i++) {
                    this.g_warehouseInfo.items[i].count = Number(this.hmjDataChange(this.g_warehouseInfo.items[i]
                        .count)) * 100 //数量
                    // this.g_warehouseInfo.items[i].stock = Number(this.hmjDataChange(this.g_warehouseInfo.items[i]
                    //     .stock)) * 100 //库存
                }

                switch (this.$route.query.type) {
                    case 0: // 新建

                        this.$requestBase({
                            url: 'v1/outbound/create',
                            method: 'POST',
                            data: this.g_warehouseInfo
                        }, true).then(res => {
                            this.$Message.success(res.info)
                            this.$router.push('outWarehouseOrderList')
                        })
                        break;

                    case 1: // 编辑
                        // 编辑时候，注意把 删除记录 抢救回来。
                        for (let i = 0; i < this.g_warehouseInfo.items_del.length; i++) {
                            this.g_warehouseInfo.items_del[i].count = Number(this.hmjDataChange(this.g_warehouseInfo
                                .items_del[i].count)) * 100 //数量

                            this.g_warehouseInfo.items.push(this.g_warehouseInfo.items_del[i])
                        }

                        this.$requestBase({
                            url: 'v1/outbound/update',
                            method: 'POST',
                            data: this.g_warehouseInfo
                        }, true).then(res => {
                            this.g_warehouseInfo.items_del = [] //为了安全，提供成功后，把临时删除列表 初始化。
                            this.$Message.success(res.info)
                            this.$router.push('outWarehouseDetalis/' + this.$route.query
                                .warehouseId) //注意这里应该返回 详情页面
                        })

                        break;
                    default:
                        break;
                }


            },



            // 字符串 '2.34512345' 四舍五入成 2位小数=2.35, 再转换成 字符串 '2.35'。注意禁止使用toFixed()。
            // https://wenku.baidu.com/view/a20d74dcadf8941ea76e58fafab069dc50224761.html
            hmjDataChange(inputStr) {
                let data1 = Number(inputStr) // 先转数字
                //Math.round()方法用来把一个数字舍入为最接近的整数
                let data2 = Math.round(data1 * 100) / 100
                return (data2.toString()) //转字符串
            },

            // 根据ID，获取 物料信息 -- 编辑专用
            getWarehouseInfo(type, warehouseId) {
                this.$requestBase({
                    url: 'v1/outbound/detail',
                    method: 'get',
                    params: {
                        id: warehouseId
                    }
                }).then(res => {
                    res = res.data
                    //this.g_warehouseInfo = res
                    this.formatResponse(res)
                })
            },


            //格式化 返回结果 -- 编辑专用
            formatResponse(res) {
                this.g_warehouseInfo = res

                for (let i = 0; i < this.g_warehouseInfo.items.length; i++) {
                    this.g_warehouseInfo.items[i].lineNo = i + 1 //手动行号

                    //hcy: 数量和之前原料是一样的处理，后端传递过来，前端需要转换下。
                    this.g_warehouseInfo.items[i].count = (this.g_warehouseInfo.items[i].count / 100).toFixed(
                        2) //数量
                    // this.g_warehouseInfo.items[i].stock = (this.g_warehouseInfo.items[i].stock / 100).toFixed(2) //库存
                }

                this.g_warehouseInfo.items_org = this.g_warehouseInfo.items //先备份原始数据。
                this.g_warehouseInfo.items = [] //清空。
                this.g_warehouseInfo.items_del = [] //同时初始化删除列表。

                //为了防止 后台把 已经删除的数据 传给前端，只有 非删除数据 才能加入'物料信息'列表。
                for (let i = 0; i < this.g_warehouseInfo.items_org.length; i++) {
                    if (this.g_warehouseInfo.items_org[i].isDeleted === 1) { //已删除脏数据
                        //do nothing.
                    } else {
                        this.g_warehouseInfo.items[i] = this.g_warehouseInfo.items_org[i]
                    }
                }

                //编辑的时候，下一个要新增的行号 应该 现有行号+1，不能直接=1。
                this.g_position_index = this.g_warehouseInfo.items.length + 1

            },


            //选择 物料 对话框 返回的处理
            updateMaterialDialog() {
                let selectedMaterial = this.$refs.materialSelect.getPeiBuInfo()
                // console.log('selectedMaterial=', selectedMaterial)
                let l_index = selectedMaterial.lineNo - 1

                this.$set(this.g_warehouseInfo.items[l_index], 'materialId', selectedMaterial.materialId)
                this.$set(this.g_warehouseInfo.items[l_index], 'materialName', selectedMaterial.name)
                this.$set(this.g_warehouseInfo.items[l_index], 'materialNumber', selectedMaterial.number)
                //解决bug: 单位显示 千克。
                this.$set(this.g_warehouseInfo.items[l_index], 'unit', selectedMaterial.unit)

                //初始化其它字段
                this.$set(this.g_warehouseInfo.items[l_index], 'count', Math.round(0).toFixed(2))
                // this.$set(this.g_warehouseInfo.items[l_index], 'stock', Math.round(0).toFixed(2))

                //通知父组件 '选择XX' 已经成功。
                this.$emit('selectWarehouseFinish', selectedMaterial)
            },

            //选择 仓位对话框 返回的处理
            updateWarehouseDialog() {
                let selectedPosition = this.$refs.warehouseSelect.getPositionInfo()
                // console.log('selectedPosition=', selectedPosition)

                // console.log('this.g_position_index = ', this.g_position_index)
                if (this.g_position_index >= 11) {
                    this.$Message.closeAll() //防止多条提示
                    this.$Message.success('最多增加10行')
                } else {
                    this.g_warehouseInfo.items.push({
                        lineNo: this.g_position_index,
                        warehouseName: selectedPosition.warehouseName,

                        positionId: selectedPosition.positionId,
                        positionName: selectedPosition.positionName,
                    })
                    this.g_position_index++
                }

                //通知父组件 '选择胚布' 已经成功。
                this.$emit('selectMaterialFinish', selectedPosition)
            },


            //删除 ---------------------------------sta
            // 显示 删除对话框
            delDialogOpend(lineNo) {
                // console.log('lineNo=', lineNo)
                this.g_delIndex = lineNo - 1 //记录下点击了 哪一行的删除按钮。

                this.delDialogVisible = true
            },
            // 监听 删除对话框 的关闭事件
            delDialogClosed() {
                this.$refs.delFormRef.resetFields()

            },
            //删除 仓位
            delWarehouse() {
                // console.log('this.g_position_index = ', this.g_position_index)
                // console.log('this.g_delIndex = ', this.g_delIndex)

                if ((this.g_position_index - 2) >= 0) {

                    switch (this.$route.query.type) {
                        case 0: // 新建
                            //新建时候，因为还没通知 后台，直接从缓存删除即可。
                            this.g_warehouseInfo.items.splice(this.g_delIndex, 1) //删除1条记录。
							for(let i = this.g_delIndex; i<this.g_warehouseInfo.items.length;i++){
								this.g_warehouseInfo.items[i].lineNo -= 1;
							}
                            break;
                        case 1: // 编辑
                            // bug: 不能直接删除items[X],要设置isDeleted=1。--sta
                            // console.log('this.g_warehouseInfo.items = ', this.g_warehouseInfo.items)
                            // console.log('this.g_warehouseInfo.items_del = ', this.g_warehouseInfo.items_del)

                            this.g_warehouseInfo.items[this.g_delIndex].isDeleted = 1 //先标记为删除。
                            this.g_warehouseInfo.items_del.push(this.g_warehouseInfo.items[this
                                .g_delIndex]) //移动到已删除列表
                            this.g_warehouseInfo.items.splice(this.g_delIndex, 1) //删除1条记录。
							for(let i = this.g_delIndex; i<this.g_warehouseInfo.items.length;i++){
								this.g_warehouseInfo.items[i].lineNo -= 1;
							}
                            // console.log('this.g_warehouseInfo.items = ', this.g_warehouseInfo.items)
                            // console.log('this.g_warehouseInfo.items_del = ', this.g_warehouseInfo.items_del)
                            // bug: 不能直接删除items[X],要设置isDeleted=1。--end
                            break;
                        default:
                            break;
                    }

                    this.g_position_index--
                }

                this.delDialogVisible = false

            },
            //删除 ---------------------------------end

            //检查物料信息表中 是否 有的行 没有选择物料?
            checkMaterialTable() {
                for (let i = 0; i < this.g_warehouseInfo.items.length; i++) {
                    // console.log('this.g_warehouseInfo.items[i].materialName=', this.g_warehouseInfo.items[i]
                    //     .materialName)
                    if (this.g_warehouseInfo.items[i].materialName === undefined) {
                        this.$Message.error('无法提交，物料信息表中某些行未选择物料！')
                        return false
                    }
                }
                return true
            },
        },
        created() {},
        // mounted:html加载完成后执行。执行顺序：子组件-父组件
        mounted() {
            switch (this.$route.query.type) {
                case 1: // 编辑
                    this.getWarehouseInfo(this.$route.query.type, this.$route.query.warehouseId)
                    break;
                case 0: // 新建
                default:
                    break;
            }
        },
        beforeDestroy() {},
        destroyed() {}

    }
</script>

<style lang="scss" scoped>
</style>
